import styled from 'styled-components';

export const Bar = styled.span<{ $color: string }>`
  display: block;
  height: 1em;
  width: 0.3rem;
  flex-shrink: 0;

  background: ${({ $color }) => $color};
  border-radius: ${({ theme }) => theme.spacing(2)};
`;
